import { useCallback, useEffect, useRef } from "react";
import { ReactSortable } from "react-sortablejs";
import "../styles/layouts/routelist.scss";

export default function RouteList({
  startingSpace,
  route,
  removeSpace,
  addSpace,
  setRoute,
  clearRoute,
}) {
  const lastChildRef = useRef(null);
  const routeLengthRef = useRef(null);

  //TODO: use ADDRESS first, use COORDINATES if address not available
  const goToGoogleMapDirections = useCallback(() => {
    const getAddressArray = (feature) => {
      let finalQuery = '';
      if (feature.mainAddress) {
        const ma = feature.mainAddress;
        finalQuery = `${ma.partOne}${ma.partTwo ? `+${ma.partTwo}` : ''}${ma.city ? `+${ma.city}` : ''}${ma.zipCode ? `+${ma.zipCode}` : ''}`;
      } else {
        finalQuery = feature.properties.address.replace(",", "").split(" ").join("+")
      }
      return finalQuery;
    };

    const routeList = [...route];
    if (!routeList || routeList.length <= 0) return;
    const destination = getAddressArray(routeList.pop());
    const url = `https://www.google.com/maps/dir/?api=1&destination=${destination}&travelmode=walking&waypoints=`;

    const finalUrl = routeList.reduce((url, feature) => {
      return `${url}${getAddressArray(feature)}|`;
    }, url);

    window.open(finalUrl);
  }, [route]);

  const removeFromRoute = useCallback(
    (space) => {
      removeSpace(space);
    },
    [removeSpace]
  );

  useEffect(() => {
    if (startingSpace) {
      addSpace(startingSpace);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    //after last child is added, always scroll to the end
    if (lastChildRef.current) {
      lastChildRef.current.scrollIntoView();
    }
    routeLengthRef.current = route.length;
  }, [route]);

  const hasRouteList = () => route && route.length > 0;

  return (
    <div className="route-list-container">
      {route && route.length > 0 && (
        <ReactSortable
          className="route-list"
          delayOnTouchOnly={true}
          delay={200}
          animation={150}
          chosenClass="route-item-chosen"
          ghostClass="route-item-ghost"
          list={route}
          setList={setRoute}
        >
          {route.map((feature, idx) => {
            const featureProps = feature.properties;
            let divProps = {};
            let animateClass = "";

            //if a new point has been added to route
            //AND it is the last added element
            //THEN add animation class
            if (
              routeLengthRef.current < route.length &&
              idx + 1 === route.length
            ) {
              divProps = {
                ref: lastChildRef,
              };

              animateClass = "route-item-added";
              // routeLengthRef.current = route.length;
            }

            return (
              <div
                {...divProps}
                key={idx}
                className={`route-item-container ${animateClass}`}
              >
                <div className="route-pointer">
                  <div>{idx + 1}</div>
                </div>
                <div className="route-item" key={featureProps.id}>
                  <div className="route-item-text truncatedText">
                    {featureProps.name}
                  </div>
                </div>
                <div className="route-item-btn-container">
                  <div className="route-item-drag"></div>
                  <div
                    onClick={() => removeFromRoute(feature)}
                    className="route-item-remove"
                  ></div>
                </div>
              </div>
            );
          })}
        </ReactSortable>
      )}

      <div
        className={`route-footer ${hasRouteList() ? "with-top-border" : ""}`}
      >
        <div className="route-go-container">
          <div onClick={goToGoogleMapDirections} className="route-go-button">
            <div className="route-go-img"></div>
            <div className="route-go-label"></div>
          </div>
          <div
            className="route-item-remove"
            onClick={() => {
              clearRoute();
            }}
          ></div>
        </div>
      </div>
    </div>
  );
}
